import React, { createContext, useContext, useEffect } from "react";
import { Activitylms, useGetAllUserDetailList } from "../../assets/api/useGetApi";
import useAuthStore from "../store/useAuthStore";
import { useLocation } from "react-router-dom";
import { ssoLogoutUrl } from "../constants";
import { indexedDBStorage } from "../utils/indexedDB/storage";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const location = useLocation();
  const isCallbackRoute = location.pathname === '/callback';

  const urlParams = new URLSearchParams(window.location.search);
  const isLoggingOut = urlParams.get('logout') === 'true';

  const { data: activityLmsData } = Activitylms();

  useEffect(() => {
    if (activityLmsData?.courses) {
      indexedDBStorage.set("activityLmsData", activityLmsData.courses);
    }
  }, [activityLmsData]);

  const { data, isLoading, error } = useGetAllUserDetailList({
    enabled: !isCallbackRoute && !isLoggingOut, // don't hydrate mid-SSO-exchange or during logout
  });

  const { login, clearAuth } = useAuthStore();

  // Handle logout redirect as a side effect, keeping hook order stable
  useEffect(() => {
    if (isLoggingOut) {
      clearAuth();
      window.location.href = ssoLogoutUrl;
    }
  }, [isLoggingOut, clearAuth]);

  useEffect(() => {
    if (isLoggingOut) return; // avoid racing with the logout redirect above

    if (data) {
      const user = data?.data || data; // Adjust based on actual API response structure
      login(user, 'true');
    } else if (!isLoading && !data) {
      const currentState = useAuthStore.getState();
      if (currentState.user || currentState.accessToken) {
        console.log("No user data found, clearing auth store.");
        clearAuth();
      }
    }
  }, [data, isLoading, isLoggingOut, login, clearAuth]);

  return (
    <AuthContext.Provider value={{ data, isLoading, error }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);